var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _path22, _path23, _path24, _g2, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 281,
    viewBox: "0 0 281 281",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_87)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.1664 146.561L52.21 174.978C52.21 174.978 48.4259 170.107 45.3297 173.151C42.2335 176.195 46.19 184.721 53.0702 181.27L57.1982 152.244C57.1982 152.244 59.9505 151.229 61.4986 154.68C63.0467 158.131 73.1956 151.026 73.1956 151.026C73.1956 151.026 66.4869 152.853 63.5631 149.2C60.6383 145.546 56.1664 146.561 56.1664 146.561Z",
    fill: "#662383"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1945 169.236L122.144 137.921C122.144 137.921 123.925 143.175 126.24 144.226L93.2898 175.12C93.2898 175.12 88.1255 174.28 89.1945 169.236Z",
    fill: "#F39200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.831 132.877L122.145 137.921C122.145 137.921 122.904 143.028 126.241 144.226L132.831 132.877Z",
    fill: "#D39757"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1944 169.237C89.1944 169.237 85.541 171.785 86.1662 174.702C86.8631 177.95 89.9067 178.064 93.2906 175.121C93.2906 175.121 88.62 174.471 89.1944 169.237Z",
    fill: "#FF8F78"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.42 135.394C127.42 135.394 128.006 137.496 129.608 138.337L132.831 132.878L127.42 135.394Z",
    fill: "#662383"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155.479 138.772L173.126 126.625L177.905 152.655C177.905 152.655 174.78 159.813 170.92 155.474C168.898 152.655 172.391 149.401 174.413 149.834L171.655 135.301L159.522 143.11L162.463 160.68C162.463 160.68 158.051 165.018 155.662 161.765C153.273 158.511 156.397 155.258 158.235 155.909L155.479 138.772Z",
    fill: "#ACE827"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M183.279 93.2131H267.168V24.6279L183.279 93.2131ZM258.705 84.0921H207.922L258.705 42.5733V84.0921Z",
    fill: "#37AAE1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0729 226.996L82.7183 256.526L112.121 246.582L117.281 218.133L88.0729 226.996Z",
    fill: "#DEDC00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0727 226.995L82.7181 256.526L58.7534 236.475L63.912 208.027L88.0727 226.995Z",
    fill: "#ACE827"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9126 208.028L88.0732 226.996L117.281 218.133L92.7834 201.021L63.9126 208.028Z",
    fill: "#662383"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6348 228.47L80.2048 252.561L61.1934 235.203L66.4243 211.995L85.6348 228.47Z",
    fill: "#A6D130"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0084 228.671L85.5225 253.409L110.155 245.079L114.477 221.246L90.0084 228.671Z",
    fill: "#F39200"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4346 209.049L88.475 224.781L112.7 217.43L92.3814 203.236L68.4346 209.049Z",
    fill: "#662383"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1006 204.785L110.96 217.959L112.7 217.43L92.3814 203.236L68.4346 209.049L69.8743 210.178L92.1006 204.785Z",
    fill: "#662383"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M112.564 221.826L108.602 243.676L85.8945 251.356L85.5225 253.409L110.155 245.079L114.477 221.246L112.564 221.826Z",
    fill: "#B57235"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3871 235.015L67.2632 213.642L65.5751 212.316L61.3291 235.733L81.0552 252.238L81.4397 250.118L63.3871 235.015Z",
    fill: "#95B22D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0185 209.428L92.6424 211.838L98.1908 211.903L94.3137 214.151L95.4266 216.913L90.4062 215.89L85.5462 217.531L86.3206 214.652L82.2046 212.906L87.7028 212.148L90.0185 209.428Z",
    fill: "#F39200"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M77.979 229.655C78.0838 233.416 76.1055 236.936 73.5591 237.514C71.0128 238.094 68.8636 235.513 68.7589 231.751C68.6541 227.99 70.6324 224.47 73.1788 223.892C75.7251 223.313 77.8743 225.892 77.979 229.655Z",
    fill: "#DEDC00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M97.181 233.817L99.6959 229.696L102.765 228.717L100.427 241.164L103.512 240.106L102.901 243.028L94.4209 245.937L95.0884 242.697L97.7406 241.804L99.0797 234.423L98.3399 235.842L97.181 233.817Z",
    fill: "#37AAE1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M259.233 138.624L254.334 128.143L255.293 127.772C256.039 127.485 256.382 126.711 256.06 126.045L255.94 125.793C255.618 125.127 254.754 124.819 254.009 125.107L242.98 129.362C242.236 129.649 241.891 130.423 242.213 131.089L242.334 131.341C242.656 132.007 243.52 132.316 244.264 132.027L245.211 131.662L250.114 142.154C249.85 142.341 249.579 142.516 249.325 142.717C241.414 148.963 240.66 159.766 247.64 166.845C254.621 173.924 266.693 174.599 274.604 168.353C282.515 162.106 283.269 151.304 276.289 144.225C271.863 139.736 265.393 137.832 259.233 138.624Z",
    fill: "#37AAE1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_759_87",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 242,
    y: 124,
    width: 40,
    height: 49
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M259.233 138.623L254.334 128.142L255.293 127.771C256.039 127.484 256.382 126.71 256.06 126.044L255.94 125.792C255.618 125.126 254.754 124.818 254.009 125.106L242.98 129.361C242.236 129.648 241.891 130.422 242.213 131.089L242.334 131.34C242.656 132.006 243.52 132.315 244.264 132.027L245.211 131.661L250.114 142.153C249.85 142.34 249.579 142.515 249.325 142.716C241.414 148.962 240.66 159.765 247.64 166.844C254.621 173.923 266.693 174.598 274.604 168.352C282.515 162.105 283.269 151.303 276.289 144.224C271.863 139.735 265.393 137.831 259.233 138.623Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_759_87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.063 146.322C246.063 146.322 250.412 152.33 258.411 151.29C266.409 150.249 269.977 153.111 272.115 155.646C274.252 158.18 280.717 155.562 281.332 154.474C281.332 154.474 281.785 163.72 274.564 168.589C267.394 173.423 260.523 173.859 252.887 170.67C243.661 166.654 239.497 154.241 246.063 146.322Z",
    fill: "#ACE827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.313 158.059C250.712 158.059 251.846 157.044 251.846 155.792C251.846 154.54 250.712 153.525 249.313 153.525C247.913 153.525 246.779 154.54 246.779 155.792C246.779 157.044 247.913 158.059 249.313 158.059Z",
    stroke: "#94C11F",
    strokeWidth: 0.7699,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.751 160.38C270.751 161.528 269.711 162.459 268.428 162.459C267.145 162.459 266.105 161.528 266.105 160.38C266.105 159.232 267.145 158.302 268.428 158.302C269.711 158.302 270.751 159.232 270.751 160.38Z",
    stroke: "#94C11F",
    strokeWidth: 0.7057,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.066 167.059C261.066 168.011 260.203 168.784 259.138 168.784C258.073 168.784 257.21 168.012 257.21 167.059C257.21 166.106 258.073 165.334 259.138 165.334C260.203 165.334 261.066 166.106 261.066 167.059Z",
    stroke: "#94C11F",
    strokeWidth: 0.5857,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.988 158.076C258.762 158.076 259.389 157.515 259.389 156.822C259.389 156.13 258.762 155.568 257.988 155.568C257.214 155.568 256.586 156.13 256.586 156.822C256.586 157.515 257.214 158.076 257.988 158.076Z",
    stroke: "#94C11F",
    strokeWidth: 0.4257,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.655 166.303C270.655 166.606 270.38 166.853 270.041 166.853C269.702 166.853 269.427 166.606 269.427 166.303C269.427 166 269.702 165.754 270.041 165.754C270.38 165.754 270.655 166 270.655 166.303Z",
    stroke: "#94C11F",
    strokeWidth: 0.1865,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.149 162.587C254.538 162.587 254.853 162.305 254.853 161.958C254.853 161.61 254.538 161.328 254.149 161.328C253.76 161.328 253.445 161.61 253.445 161.958C253.445 162.305 253.76 162.587 254.149 162.587Z",
    stroke: "#94C11F",
    strokeWidth: 0.2139,
    strokeMiterlimit: 10
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M163.714 45.1909L82.4951 119.36L89.8897 130.635L171.109 56.4657L163.714 45.1909Z",
    fill: "#DEDC00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5063 119.364L84.7205 122.686L165.558 47.9775L163.73 45.1924L82.5063 119.364Z",
    fill: "#B1771A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_759_87",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 45,
    width: 84,
    height: 78
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5063 119.365L84.7205 122.687L165.558 47.9785L163.73 45.1934L82.5063 119.365Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_759_87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.0781 118.062L85.2914 119.999",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6855 116.46L85.8988 118.397",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2192 116.081L87.4325 118.018",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8271 114.48L88.0404 116.418",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3247 114.144L89.538 116.081",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9321 112.544L90.1454 114.481",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4673 112.125L91.6805 114.062",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0728 110.523L92.2869 112.46",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6436 110.229L93.8568 112.167",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.25 108.628L94.4642 110.565",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.749 107.995L95.9623 109.932",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.356 106.395L96.5692 108.332",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8188 105.933L98.0321 107.87",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4263 104.332L98.6395 106.269",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0317 103.954L100.246 105.891",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6387 102.354L100.852 104.292",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.244 102.06L102.457 103.997",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.851 100.459L103.064 102.396",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.385 99.9121L104.599 101.849",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.992 98.3105L105.205 100.248",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.634 98.0576L106.847 99.9947",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.24 96.457L107.453 98.3941",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.811 95.9531L109.024 97.8902",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.417 94.3516L109.63 96.2886",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.023 94.0586L111.236 95.9956",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.63 92.458L111.843 94.3951",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.2 92.1201L113.413 94.0572",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.808 90.5195L114.021 92.4566",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.448 90.1816L115.661 92.1187",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.056 88.582L116.269 90.5191",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.554 87.9932L117.767 89.9302",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.161 86.3926L118.374 88.3307",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.695 85.9736L119.909 87.9107",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.302 84.373L120.516 86.3101",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.8 83.9092L122.014 85.8462",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.408 82.3086L122.621 84.2456",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.013 82.2676L124.227 84.2057",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.621 80.667L124.834 82.604",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.119 80.2861L126.332 82.2232",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.726 78.6865L126.939 80.6236",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.26 78.4775L128.473 80.4146",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.867 76.877L129.08 78.814",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.437 76.4531L130.651 78.3902",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.044 74.8535L131.257 76.7906",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.65 74.3496L132.863 76.2867",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.257 72.749L133.47 74.685",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.791 72.2041L135.004 74.1412",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.398 70.6035L135.612 72.5406",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.933 70.2236L137.146 72.1607",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.539 68.623L137.753 70.5601",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.145 68.2451L139.358 70.1811",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.752 66.6436L139.966 68.5806",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.465 66.2627L141.679 68.1998",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.072 64.6631L142.285 66.6001",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.606 64.2871L143.819 66.2242",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.212 62.6855L144.426 64.6226",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.925 62.1387L146.139 64.0757",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.533 60.5381L146.746 62.4751",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.246 59.9043L148.459 61.8414",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.851 58.3037L149.064 60.2408",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.565 57.6318L150.778 59.5689",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.172 56.0312L151.386 57.9683",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.67 55.6104L152.884 57.5474",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.277 54.0098L153.491 55.9468",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.883 53.7988L155.097 55.7359",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.49 52.1982L155.703 54.1353",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.06 51.8623L157.273 53.7994",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.667 50.2617L157.88 52.1988",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.273 50.0928L159.486 52.0298",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.879 48.4922L160.093 50.4293",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.521 48.1562L161.735 50.0933",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.127 46.5557L162.341 48.4927",
    stroke: "#F9FBFC",
    strokeWidth: 0.4719,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3937 72.9595C73.2168 74.4864 71.6904 78.7631 72.9845 82.5109C74.2785 86.2597 77.9028 88.0608 81.0789 86.5339C84.2559 85.0069 85.7822 80.7302 84.4882 76.9813C83.1942 73.2336 79.5698 71.4325 76.3937 72.9595ZM80.2196 84.0443C78.2077 85.0112 75.9128 83.8708 75.0934 81.4969C74.2739 79.1229 75.2404 76.4149 77.2522 75.449C79.264 74.4821 81.558 75.6225 82.3775 77.9964C83.1978 80.3704 82.2314 83.0773 80.2196 84.0443Z",
    fill: "#37AAE1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8794 73.6907L80.707 56.2871L86.0101 58.4833L82.609 74.1018C82.609 74.1018 79.2524 71.4966 76.8794 73.6907Z",
    fill: "#37AAE1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7065 56.2871L85.2656 35.6829C85.2656 35.6829 86.2011 30.2712 89.3219 31.5283C92.4426 32.7854 91.0397 37.181 91.0397 37.181L86.0106 58.4833L80.7065 56.2871Z",
    fill: "#C1C1C1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5632 73.5831C92.8572 77.332 96.4816 79.133 99.6576 77.6061C102.835 76.0792 104.361 71.8024 103.067 68.0547C101.773 64.3058 98.1485 62.5048 94.9725 64.0317C91.7946 65.5576 90.2692 69.8343 91.5632 73.5831ZM93.6721 72.5691C92.8527 70.1952 93.8191 67.4882 95.8309 66.5213C97.8427 65.5544 100.138 66.6948 100.956 69.0687C101.776 71.4426 100.809 74.1507 98.7974 75.1165C96.7865 76.0834 94.4915 74.942 93.6721 72.5691Z",
    fill: "#37AAE1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0559 64.9536L82.0122 55.6592L79.5186 61.6021L91.2001 69.9713C91.2001 69.9713 92.0586 65.3402 95.0559 64.9536Z",
    fill: "#37AAE1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0133 55.6602L66.5513 44.6782C66.5513 44.6782 62.6774 41.5783 61.1892 45.0498C59.7009 48.5224 63.3071 50.5108 63.3071 50.5108L79.5187 61.6031L82.0133 55.6602Z",
    fill: "#D1D1D1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1448 59.9089C83.3253 60.4315 83.1121 61.0268 82.6693 61.2399C82.2264 61.453 81.7219 61.2014 81.5413 60.6788C81.3607 60.1563 81.574 59.5609 82.0159 59.3478C82.4596 59.1358 82.9651 59.3864 83.1448 59.9089Z",
    fill: "#D1D1D1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M141.649 211.39C141.649 211.39 158.88 183.398 186.619 201.674C186.619 201.674 199.589 183.448 213.685 194.85L231.777 233.831C231.777 233.831 213.612 229.127 204.089 240.36C204.089 240.36 199.771 247.792 190.707 241.083C190.707 241.083 172.17 235.349 157.762 256.053L141.649 211.39Z",
    fill: "#662383"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M159.748 246.111L161.405 234.06C161.405 234.06 185.764 217.222 198.676 233.984C198.676 233.984 210.007 214.48 231.778 222.371L230.379 228.955C230.379 228.955 215.491 222.41 200.352 237.233C200.352 237.233 198.689 239.677 196.397 237.362C196.397 237.362 177.518 227.129 159.748 246.111Z",
    fill: "#E5DFCF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M143.5 202.588L144.422 193.112L161.404 234.06L159.747 246.111L143.5 202.588Z",
    fill: "#D6CABF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M185.338 190.734C185.338 190.734 161.596 176.418 144.423 193.112L161.404 234.06C161.404 234.06 186.646 217.547 198.676 233.984C198.676 233.984 210.438 214.731 231.778 222.372L215.05 185.809C215.05 185.809 198.484 174.059 185.338 190.734Z",
    fill: "#FFFCE5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M185.337 190.732C187.006 194.06 188.518 197.492 189.969 200.96C191.417 204.429 192.728 207.976 193.999 211.544C195.213 215.139 196.334 218.787 197.234 222.518C198.111 226.237 198.855 230.097 198.676 233.981C198.583 233.016 198.543 232.055 198.431 231.105C198.271 230.16 198.132 229.214 197.956 228.279L197.349 225.487C197.127 224.563 196.867 223.651 196.627 222.733C195.61 219.082 194.504 215.459 193.237 211.909C192.035 208.329 190.719 204.802 189.398 201.274C188.07 197.751 186.705 194.246 185.337 190.732Z",
    fill: "#D6CABF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M150.877 196.363C150.877 196.363 170.753 185.669 183.729 194.055",
    stroke: "#D6CABF",
    strokeWidth: 0.9079,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M152.319 200.738C152.319 200.738 172.195 190.044 185.17 198.43",
    stroke: "#D6CABF",
    strokeWidth: 0.9079,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M154.173 204.748C154.173 204.748 174.049 194.054 187.024 202.439",
    stroke: "#D6CABF",
    strokeWidth: 0.9079,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M156.335 209.002C156.335 209.002 176.211 198.308 189.187 206.693",
    stroke: "#D6CABF",
    strokeWidth: 0.9079,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M158.292 213.62C158.292 213.62 178.167 202.926 191.143 211.311",
    stroke: "#D6CABF",
    strokeWidth: 0.9079,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M192.379 215.2C179.404 206.815 159.528 217.509 159.528 217.509",
    stroke: "#D6CABF",
    strokeWidth: 0.9079,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M161.176 222.005C161.176 222.005 181.052 211.311 194.027 219.696",
    stroke: "#D6CABF",
    strokeWidth: 0.9079,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M162.926 227.23C162.926 227.23 182.802 216.536 195.778 224.922",
    stroke: "#D6CABF",
    strokeWidth: 0.9079,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M188.981 193.569C188.981 193.569 196.293 182.268 213.079 187.979",
    stroke: "#D6CABF",
    strokeWidth: 0.9079,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M190.423 197.579C190.423 197.579 197.734 186.277 214.521 191.989",
    stroke: "#D6CABF",
    strokeWidth: 0.9079,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M192.071 201.345C192.071 201.345 199.383 190.044 216.17 195.756",
    stroke: "#D6CABF",
    strokeWidth: 0.9079,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M196.911 214.228C196.911 214.228 204.223 202.927 221.009 208.638",
    stroke: "#D6CABF",
    strokeWidth: 0.9079,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M200.516 224.436C200.516 224.436 207.828 213.135 224.614 218.846",
    stroke: "#D6CABF",
    strokeWidth: 0.9079,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M195.263 209.489C195.263 209.489 202.575 198.188 219.361 203.899",
    stroke: "#D6CABF",
    strokeWidth: 0.9079,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M198.867 219.21C198.867 219.21 206.179 207.909 222.965 213.621",
    stroke: "#D6CABF",
    strokeWidth: 0.9079,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M193.821 205.356C193.821 205.356 201.133 194.055 217.919 199.766",
    stroke: "#D6CABF",
    strokeWidth: 0.9079,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M224.084 155.399C224.084 155.399 218.378 139.176 203.435 124.422C203.435 124.422 198.303 119.092 196.677 120.236C195.865 120.625 195.769 123.093 199.005 128.174C201.597 132.242 215.673 154.564 221.628 157.728L224.084 155.399Z",
    fill: "#DEDC00"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M224.084 155.398C224.084 155.398 230.766 156.77 230.064 164.361C229.864 166.217 232.721 167.276 232.721 167.276C232.721 167.276 225.753 172.667 221.628 157.728L224.084 155.398Z",
    fill: "#662383"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M218.643 144.09L213.514 149.264C213.514 149.264 219.458 157.155 221.629 157.727L224.085 155.398C224.085 155.398 222.363 149.093 218.643 144.09Z",
    fill: "#828282"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M232.721 167.274C232.115 167.271 231.497 167.218 230.913 166.963C230.334 166.699 229.848 166.15 229.574 165.494C229.288 164.841 229.137 164.129 229.025 163.418C228.915 162.706 228.885 161.973 228.751 161.304C228.438 159.946 227.606 158.826 226.636 157.993C225.656 157.165 224.563 156.51 223.419 156.028C224.592 156.412 225.721 157.015 226.724 157.849C227.722 158.672 228.611 159.799 228.969 161.236C229.1 161.97 229.113 162.679 229.209 163.382C229.306 164.083 229.444 164.782 229.706 165.414C229.958 166.051 230.404 166.569 230.953 166.844C231.503 167.128 232.117 167.228 232.721 167.274Z",
    fill: "#422208"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M222.664 156.742C223.727 157.088 224.72 157.747 225.542 158.632C226.376 159.509 226.991 160.66 227.361 161.902C227.704 163.137 228.021 164.382 228.55 165.504C228.809 166.066 229.164 166.562 229.618 166.911C230.072 167.259 230.604 167.46 231.134 167.628C230.596 167.501 230.053 167.346 229.56 167.023C229.075 166.684 228.685 166.175 228.4 165.609C227.824 164.475 227.505 163.208 227.148 161.988C226.806 160.776 226.211 159.667 225.425 158.78C224.642 157.892 223.699 157.181 222.664 156.742Z",
    fill: "#422208"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M221.983 157.458C222.921 158.012 223.751 158.808 224.462 159.725C225.164 160.652 225.748 161.715 226.15 162.871C226.513 164.043 226.863 165.184 227.504 166.156C228.121 167.117 228.974 167.931 229.998 168.211C228.953 168.031 228.026 167.254 227.367 166.283C226.681 165.321 226.308 164.102 225.94 162.973C225.565 161.834 224.993 160.799 224.331 159.861C223.655 158.937 222.879 158.096 221.983 157.458Z",
    fill: "#422208"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7052 197.111C32.6342 197.675 32.5462 198.314 32.4177 198.907L32.137 200.473C31.9679 201.521 31.8225 202.575 31.7016 203.632C31.4683 205.747 31.3482 207.881 31.344 210.011C31.3338 214.272 31.7608 218.525 32.6367 222.622C33.6166 226.671 34.7562 230.689 36.5325 234.28L37.1556 235.651C37.3577 236.113 37.6307 236.518 37.8641 236.953L39.3174 239.523C39.8509 240.331 40.4106 241.111 40.9542 241.907C41.2298 242.3 41.4962 242.705 41.7794 243.088L42.6882 244.168C45.0276 247.162 47.8074 249.528 50.6617 251.616L52.8691 253.047C53.6089 253.512 54.3986 253.839 55.1595 254.242L56.3101 254.822C56.6973 255.001 57.1015 255.12 57.4954 255.272L59.8728 256.138L62.3035 256.71C62.7093 256.793 63.1101 256.929 63.521 256.97L64.7519 257.102C65.5729 257.17 66.3896 257.329 67.2122 257.325L69.6784 257.281C70.5018 257.318 71.3152 257.121 72.1327 257.021L73.3569 256.844C73.7661 256.793 74.1728 256.733 74.5718 256.6C76.1748 256.143 77.7913 255.769 79.3495 255.105L80.3057 254.699L80.8933 255.814C84.5236 262.708 89.598 268.326 95.4561 271.924C101.326 275.472 107.916 277.059 114.374 276.308C120.811 275.487 127.122 272.625 132.302 267.716C137.534 262.91 141.643 256.23 144.17 248.711L145.222 245.582L147.173 247.962C149.742 251.095 152.793 253.634 156.153 255.164C157.827 255.942 159.561 256.502 161.323 256.834C163.09 257.129 164.875 257.206 166.651 257.057C170.201 256.744 173.713 255.467 176.84 253.311C179.979 251.174 182.726 248.142 184.889 244.546L185.998 242.702L187.464 244.041C194.078 250.08 202.351 253.135 210.513 252.502C212.55 252.337 214.59 252.018 216.581 251.398C217.587 251.142 218.547 250.672 219.534 250.323C220.02 250.118 220.528 249.985 220.996 249.72L222.414 248.966C226.193 246.957 229.714 244.136 232.762 240.622C238.812 233.524 242.895 223.771 244.137 213.368C244.769 208.166 244.592 202.826 243.792 197.657C243.08 192.449 241.507 187.459 239.397 182.892L237.761 179.35L240.585 181.312C242.322 182.519 244.16 183.5 246.069 184.191C247.979 184.873 249.951 185.276 251.935 185.405C253.92 185.534 255.917 185.341 257.875 184.893C258.856 184.679 259.822 184.365 260.769 183.969L262.197 183.411L263.573 182.671C267.231 180.68 270.544 177.611 273.088 173.708C275.652 169.831 277.527 165.227 278.532 160.325C279.525 155.414 279.544 150.217 278.707 145.275C278.351 142.779 277.627 140.398 276.834 138.084C275.965 135.809 274.943 133.624 273.707 131.637C272.454 129.677 271.093 127.807 269.515 126.257C268.769 125.416 267.907 124.766 267.1 124.029C266.232 123.411 265.4 122.707 264.484 122.202C260.914 119.945 256.927 118.857 252.954 118.81L251.295 118.791L252.367 117.183C253.737 115.13 254.866 112.809 255.616 110.293C256.383 107.792 256.804 105.122 256.866 102.449C256.914 101.111 256.821 99.7746 256.699 98.4479C256.528 97.1297 256.324 95.8148 255.999 94.5438C255.366 91.9974 254.389 89.5978 253.13 87.4669L252.65 86.6542L253.201 85.8832C256.802 80.8419 259.519 74.822 261.121 68.364C262.722 61.8986 263.116 55.0081 262.405 48.3339C261.622 41.6746 259.789 35.1867 256.873 29.5822C253.975 23.9638 250.091 19.2127 245.631 15.6576C241.171 12.1058 236.101 9.75224 230.873 9.01982L228.91 8.79817C228.583 8.76712 228.257 8.70822 227.93 8.69966L226.945 8.71465L224.976 8.73928C224.319 8.70715 223.67 8.8924 223.018 8.95557L221.062 9.22863C220.416 9.36997 219.778 9.57235 219.136 9.73832C218.496 9.91929 217.851 10.0724 217.215 10.2737L215.332 10.9933C210.355 13.0952 205.782 16.6053 201.995 21.1647C198.206 25.7231 195.228 31.3511 193.324 37.5092L189.622 49.4839L189.502 36.6226C189.436 29.5629 187.367 22.6253 183.91 17.1621C180.456 11.6518 175.456 7.82696 170.094 6.20365C167.406 5.37164 164.606 5.24743 161.871 5.61364L160.843 5.75285C160.5 5.79461 160.167 5.92417 159.828 6.00341C159.157 6.20365 158.47 6.32786 157.81 6.58164C156.475 7.03244 155.19 7.68348 153.941 8.41269C148.949 11.3756 144.829 16.5443 142.367 22.7805L140.728 26.9309L138.553 23.1906C136.742 20.0768 134.178 17.6718 131.301 16.3794C128.427 15.073 125.261 14.8974 122.303 15.8782C119.345 16.8527 116.648 18.9568 114.643 21.8714C112.629 24.7733 111.322 28.4547 110.933 32.2849L110.657 34.9993L108.511 34.7755C105.769 34.4896 103.003 34.6106 100.284 35.1375C97.5672 35.6675 94.8897 36.6001 92.3406 37.914C89.7865 39.215 87.3592 40.9122 85.1205 42.9435C82.875 44.9662 80.8332 47.3455 79.0147 49.9711L77.7693 51.769L76.2095 50.4744C68.6604 44.2081 59.2058 41.6896 50.2914 43.8162C45.8528 44.9245 41.5325 46.9547 37.6992 50.0407C33.8592 53.101 30.4901 57.1229 27.8295 61.8033C22.4795 71.146 20.0572 83.1677 21.3888 94.6626C21.776 97.5141 22.1996 100.381 22.9461 103.13C23.6597 105.891 24.6058 108.553 25.7277 111.091C27.9647 116.175 31.0109 120.684 34.5964 124.363L35.4081 125.196L34.9946 126.359C32.7001 132.807 32.1345 140.226 33.4246 147.165L33.7747 149.047L32.2774 148.946C27.3104 148.611 22.2402 150.983 18.6242 155.392C14.9702 159.752 12.7712 166.067 12.7492 172.508C12.7086 178.929 14.7292 185.447 18.4593 189.968C20.2999 192.235 22.4845 194.1 24.9034 195.283C25.5095 195.568 26.1132 195.876 26.7447 196.069C27.0576 196.176 27.3687 196.299 27.684 196.393L28.6411 196.623C29.2769 196.811 29.9287 196.84 30.5755 196.938C31.229 197.002 32.0364 197.022 32.7052 197.111ZM32.3721 197.44C31.7228 197.508 31.2079 197.624 30.5476 197.567C29.8831 197.498 29.2092 197.497 28.5515 197.337L27.5581 197.146C27.23 197.063 26.9062 196.953 26.5799 196.858C25.9213 196.687 25.2889 196.402 24.6514 196.134C22.1058 195.032 19.7698 193.187 17.783 190.871C13.751 186.267 11.4125 179.439 11.2925 172.523C11.1521 165.587 13.3528 158.602 17.2791 153.646C21.1885 148.666 26.7752 145.849 32.3628 146.068L31.2155 147.85C29.6827 140.356 30.1468 132.196 32.5538 125.017L32.952 127.012C25.0851 119.39 19.6075 107.778 18.1795 95.2559C16.5968 82.7512 19.09 69.5248 24.8695 59.1424C27.7432 53.9405 31.415 49.4314 35.6355 45.9653C39.8492 42.4724 44.6176 40.1263 49.5398 38.8188C54.4789 37.551 59.6251 37.566 64.5837 38.7696C69.5448 39.9838 74.3106 42.4338 78.5598 45.901L75.7555 46.4043C77.7786 43.4425 80.0596 40.7548 82.5723 38.4601C85.0782 36.1568 87.8023 34.2241 90.6692 32.7367C93.5319 31.2366 96.5315 30.1658 99.5938 29.5436C102.656 28.9258 105.777 28.7641 108.869 29.0629L106.447 31.5535C106.939 26.5915 108.638 21.8511 111.242 18.098C113.834 14.3309 117.354 11.5919 121.17 10.3455C124.982 9.08086 129.11 9.31322 132.819 11.0083C136.533 12.6841 139.831 15.784 142.168 19.808L138.355 20.2181C141.282 12.879 146.195 6.83648 152.094 3.39925C153.568 2.55225 155.086 1.80806 156.652 1.29087C157.428 1.00282 158.232 0.851842 159.022 0.63126C159.42 0.540243 159.812 0.402113 160.215 0.352856L161.423 0.196517C164.638 -0.2061 167.923 -0.0122868 171.065 0.984618C177.335 2.93667 183.118 7.46504 187.106 13.9133C191.103 20.3199 193.432 28.3872 193.464 36.5498L189.643 35.6632C191.796 28.8455 195.135 22.6413 199.363 17.63C203.58 12.5995 208.711 8.83351 214.209 6.60305L216.289 5.846C216.99 5.63506 217.701 5.47337 218.406 5.28705C219.115 5.11465 219.818 4.90906 220.529 4.76665L222.683 4.49681C223.401 4.43685 224.115 4.25695 224.838 4.29764L227 4.30407L228.081 4.30942C228.441 4.32549 228.799 4.39294 229.157 4.43256L231.307 4.71204C237.03 5.61686 242.539 8.27777 247.353 12.2247C252.179 16.1631 256.285 21.4688 259.325 27.6066C262.379 33.7465 264.236 40.7634 264.958 47.9077C265.613 55.0734 265.056 62.4072 263.268 69.2303C261.474 76.048 258.511 82.3443 254.644 87.5697L254.715 85.986C256.074 88.3685 257.115 91.0401 257.771 93.852C258.107 95.2558 258.313 96.7003 258.479 98.147C258.595 99.6022 258.673 101.067 258.603 102.529C258.495 105.448 257.995 108.345 257.125 111.041C256.263 113.746 255.042 116.254 253.545 118.463L252.958 116.837C257.169 116.917 261.38 118.109 265.138 120.52C266.101 121.063 266.977 121.809 267.888 122.471C268.738 123.253 269.64 123.95 270.424 124.841C272.077 126.49 273.505 128.47 274.812 130.545C280.016 138.958 281.79 150.407 279.784 160.713C278.75 165.861 276.8 170.704 274.12 174.794C271.464 178.922 267.975 182.133 264.15 184.314L262.706 185.118L261.206 185.733C260.211 186.167 259.194 186.514 258.159 186.758C256.095 187.267 253.981 187.505 251.874 187.404C247.654 187.225 243.484 185.778 239.738 183.292L240.926 181.711C243.218 186.435 244.964 191.645 245.813 197.114C246.749 202.545 247.034 208.205 246.457 213.759C245.33 224.865 241.15 235.441 234.738 243.276C231.51 247.16 227.744 250.325 223.669 252.619L222.138 253.478C221.631 253.777 221.085 253.942 220.56 254.179C219.493 254.591 218.45 255.122 217.361 255.433C215.201 256.162 212.977 256.577 210.748 256.814C201.801 257.712 192.657 254.438 185.302 247.895L187.876 247.389C185.412 251.53 182.252 255.023 178.642 257.499C175.038 259.994 171.017 261.469 166.924 261.846C164.878 262.027 162.816 261.945 160.783 261.579C158.754 261.185 156.76 260.528 154.84 259.62C150.988 257.831 147.499 254.903 144.573 251.286L147.576 250.537C144.757 258.81 140.198 266.132 134.414 271.389C128.665 276.735 121.708 279.759 114.663 280.554C107.588 281.266 100.399 279.452 94.0755 275.459C87.7761 271.393 82.3982 265.176 78.6165 257.666L80.1602 258.375C78.477 259.043 76.7353 259.41 75.0115 259.85C74.5828 259.979 74.1449 260.033 73.7061 260.079L72.3923 260.238C71.5155 260.323 70.6439 260.504 69.7621 260.448L67.126 260.426C66.2484 260.407 65.3767 260.221 64.5034 260.124L63.1946 259.946C62.7584 259.891 62.3331 259.739 61.9019 259.639L59.3258 258.962L56.8132 257.982C56.3972 257.809 55.9719 257.669 55.5644 257.469L54.3529 256.826C53.5523 256.38 52.7246 256.007 51.9484 255.497L49.6378 253.924C46.6441 251.66 43.7848 249.04 41.4074 245.8L40.485 244.63C40.1975 244.217 39.9278 243.782 39.6497 243.359C39.1001 242.504 38.5362 241.664 38.0011 240.799L36.5494 238.055C36.3169 237.592 36.0464 237.158 35.846 236.669L35.2314 235.214C33.4796 231.407 32.3983 227.194 31.4962 222.984C30.7057 218.726 30.3531 214.338 30.5045 209.983C30.5806 207.807 30.7733 205.639 31.0811 203.501C31.2392 202.432 31.4209 201.372 31.6272 200.319L31.9637 198.749C32.0626 198.31 32.2097 197.914 32.3721 197.44Z",
    fill: "#37AAE1"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9951 135.584C22.0118 130.155 18.5482 124.466 13.2589 122.877C7.96954 121.288 2.85753 124.401 1.84086 129.829C0.824179 135.258 4.28783 140.946 9.57714 142.535C14.8664 144.124 19.9785 141.012 20.9951 135.584Z",
    stroke: "#37AAE1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M276.192 105.624C276.192 108.178 274.134 110.247 271.596 110.247C269.057 110.247 267 108.178 267 105.624C267 103.07 269.057 101 271.596 101C274.134 101 276.192 103.071 276.192 105.624Z",
    stroke: "#37AAE1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7742 7.16566C98.7742 9.7195 96.7169 11.7893 94.1784 11.7893C91.6399 11.7893 89.5825 9.7195 89.5825 7.16566C89.5825 4.61183 91.6399 2.54199 94.1784 2.54199C96.7169 2.54199 98.7742 4.61183 98.7742 7.16566Z",
    stroke: "#37AAE1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_87"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 281,
    height: 281,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearning);
export default __webpack_public_path__ + "static/media/learning.c05bf7a0b4f25945bd048f0b96887484.svg";
export { ForwardRef as ReactComponent };